import Banner from '@carvana/ds-banner';
import React from 'react';
import styles from './digital-wallet-unavailable-banner.module.css';
import type { DigitalWallet } from '../../../services/purchase-payments-api.types';
import { getDigitalWalletLabel } from '../utils';

type DigitalWalletUnavailableReason = 'UnsupportedDevice' | 'CardIneligible';

interface DigitalWalletUnavailableBannerProps {
  reason: DigitalWalletUnavailableReason;
  digitalWallet: DigitalWallet | undefined;
  editPaymentMethod: () => void;
}

const getCardIneligibleHeadline = (digitalWallet: DigitalWallet | undefined) => {
  switch (digitalWallet) {
    case 'ApplePay':
      return 'Apple Pay is no longer available';
    case 'GooglePay':
      return 'Google Pay is no longer available';
    default:
      return 'Apple Pay and Google Pay are no longer available';
  }
};

const ChangePaymentMethodButton = ({ editPaymentMethod }: { editPaymentMethod: () => void }) => {
  return (
    <button
      type="button"
      className={styles.link}
      onClick={editPaymentMethod}
      data-analytics-id="pp_complete_purchase_wallet_unavailable_edit_payment"
    >
      change your payment method
    </button>
  );
};

export const DigitalWalletUnavailableBanner = ({
  reason,
  digitalWallet,
  editPaymentMethod
}: DigitalWalletUnavailableBannerProps) => {
  const walletLabel = getDigitalWalletLabel(digitalWallet);

  if (reason === 'CardIneligible') {
    return (
      <Banner align="left" icon open type="warning">
        <Banner.Headline>{getCardIneligibleHeadline(digitalWallet)}</Banner.Headline>
        <Banner.Message>
          Please <ChangePaymentMethodButton editPaymentMethod={editPaymentMethod} />.
        </Banner.Message>
      </Banner>
    );
  }

  return (
    <Banner align="left" icon open type="warning">
      <Banner.Headline>Please use a device that supports {walletLabel}</Banner.Headline>
      <Banner.Message>
        <>
          Your current device does not support {walletLabel}. Please switch to a device that
          supports {walletLabel} or{' '}
          <ChangePaymentMethodButton editPaymentMethod={editPaymentMethod} />.
        </>
      </Banner.Message>
    </Banner>
  );
};
